module.exports = __webpack_public_path__ + "static/lighting-table-sorting-2166b73e3e2f628f0cba008fb0165302.png";